export const DEFAULT_SECTION_CONTENT_PROPERTIES = {
    backgroundColor: undefined,
    paddingTop: 16,
    paddingBottom: 16,
    displayDelayInSeconds: 0,
    maxWidth: 'L',
    verticalAlignment: 'top',
};
